import { render, staticRenderFns } from "./TopicOptionComponent.vue?vue&type=template&id=3aae2ad1&"
import script from "./TopicOptionComponent.vue?vue&type=script&lang=js&"
export * from "./TopicOptionComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports